import {
    isEuCountryCode,
    isSwedenCountryCode
} from 'tradera/utils/allowed-buyer-region';
import constants from '../constants/constants';

const getDefaultAllowedBuyerRegionsFilter = (countryCodeIso2: string) =>
    isSwedenCountryCode(countryCodeIso2)
        ? constants.FILTER_STATES_ALLOWED_BUYER_REGIONS.SWEDEN
        : isEuCountryCode(countryCodeIso2)
          ? constants.FILTER_STATES_ALLOWED_BUYER_REGIONS.EU
          : constants.FILTER_STATES_ALLOWED_BUYER_REGIONS.INTERNATIONAL;

export const getActiveFilterStatesAllowedBuyerRegions = (
    countryCodeIso2: string
) =>
    Object.values(constants.FILTER_STATES_ALLOWED_BUYER_REGIONS).filter(
        (x) => x !== getDefaultAllowedBuyerRegionsFilter(countryCodeIso2)
    );

export const getActiveFilterStates = (countryCodeIso2: string) => {
    return [
        ...constants.ACTIVE_FILTER_STATES_ITEM_CONDITION,
        ...constants.ACTIVE_FILTER_STATES_SELLER_TYPE,
        ...constants.ACTIVE_FILTER_STATES_ITEM_STATUS,
        ...constants.ACTIVE_FILTER_STATES_ITEM_TYPE,
        ...constants.ACTIVE_FILTER_STATES_COUNTY,
        ...getActiveFilterStatesAllowedBuyerRegions(countryCodeIso2)
    ];
};
